"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagInput = void 0;
const react_1 = __importStar(require("react"));
const public_1 = require("../../common/public");
const Dropdown_1 = require("../Dropdown");
const useControlState_1 = require("../helpers/useControlState");
const helpers_1 = require("../../helpers");
const getStylesWithMaxWidth_1 = require("../../helpers/getStylesWithMaxWidth");
const Suggest_1 = require("../../Suggest");
const TagInputControl_1 = require("./components/TagInputControl/TagInputControl");
const constants_1 = require("./helpers/constants");
const AddIcon_1 = require("./icons/AddIcon");
exports.TagInput = (0, helpers_1.createUIElement)('TagInput', (_a, ref) => {
    var { className, placeholder, value = [], disabled, data = [], error, newTagError, canAdd = true, onChange, onFocus, onBlur, size = public_1.CONTROL_SIZE.m, texts, maxNumberOfLines = 4, hasSuggest = true, onCreateNew, validateNewItem, onNewTagErrorChange, hasEnterKeyStopPropagation = true, hasBlurEnter = false, hasBorder = true, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "placeholder", "value", "disabled", "data", "error", "newTagError", "canAdd", "onChange", "onFocus", "onBlur", "size", "texts", "maxNumberOfLines", "hasSuggest", "onCreateNew", "validateNewItem", "onNewTagErrorChange", "hasEnterKeyStopPropagation", "hasBlurEnter", "hasBorder", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const buttonRef = ref !== null && ref !== void 0 ? ref : (0, react_1.useRef)(null);
    const tags = (0, react_1.useMemo)(() => Array.from(new Set(value)) || [], [value]);
    const valueState = (0, helpers_1.useStateValue)(tags, [tags]);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const hasAddAction = (0, react_1.useMemo)(() => searchTerm && canAdd && !(data === null || data === void 0 ? void 0 : data.includes(searchTerm)), [canAdd, data, searchTerm]);
    const { active, focused, activate, preventBlur, input } = (0, useControlState_1.useControlState)({
        rootRef: buttonRef,
        onBlur: () => {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        },
        onFocus: onFocus
    });
    const validateNewTag = (0, react_1.useCallback)((value) => {
        var _a;
        const error = (_a = validateNewItem === null || validateNewItem === void 0 ? void 0 : validateNewItem(value)) !== null && _a !== void 0 ? _a : '';
        if (error) {
            onNewTagErrorChange === null || onNewTagErrorChange === void 0 ? void 0 : onNewTagErrorChange(error);
        }
        return !error;
    }, [onNewTagErrorChange, validateNewItem]);
    const onSearchHandler = (0, react_1.useCallback)((value) => {
        if (newTagError) {
            onNewTagErrorChange === null || onNewTagErrorChange === void 0 ? void 0 : onNewTagErrorChange('');
        }
        setSearchTerm(value);
    }, [newTagError, onNewTagErrorChange]);
    const getDefaultPlaceholder = (0, react_1.useCallback)((hasSuggest) => {
        if (hasSuggest) {
            return constants_1.DEFAULT_TEXTS.placeholderWithSuggest;
        }
        return constants_1.DEFAULT_TEXTS.placeholderWithoutSuggest;
    }, []);
    const controlError = (0, react_1.useMemo)(() => error || newTagError, [error, newTagError]);
    const controlPlaceholder = (0, react_1.useMemo)(() => placeholder || getDefaultPlaceholder(hasSuggest), [getDefaultPlaceholder, hasSuggest, placeholder]);
    const receivedValue = (0, react_1.useMemo)(() => valueState.getValue(), [valueState]);
    const rendererEmptyMessage = (0, react_1.useMemo)(() => (0, Suggest_1.createEmptyMessageRenderer)({
        text: (texts === null || texts === void 0 ? void 0 : texts.empty) || 'No tags found'
    }), [texts === null || texts === void 0 ? void 0 : texts.empty]);
    const rendererData = (0, react_1.useMemo)(() => data.map((tag) => ({
        tag
    })), [data]);
    const handleRenderTrailerItemClick = (0, react_1.useCallback)(() => {
        if (!validateNewTag(searchTerm)) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange([...receivedValue, searchTerm]);
        setSearchTerm('');
        onCreateNew === null || onCreateNew === void 0 ? void 0 : onCreateNew(searchTerm);
    }, [onChange, onCreateNew, receivedValue, searchTerm, validateNewTag]);
    const renderTrailerItem = (0, react_1.useMemo)(() => hasAddAction
        ? (0, Suggest_1.createNewItemActionRenderer)({
            action: {
                text: (texts === null || texts === void 0 ? void 0 : texts.createNew) || 'Create New',
                icon: react_1.default.createElement(AddIcon_1.AddIcon, null),
                onClick: handleRenderTrailerItemClick
            }
        })
        : undefined, [handleRenderTrailerItemClick, hasAddAction, texts === null || texts === void 0 ? void 0 : texts.createNew]);
    const [control] = (0, Dropdown_1.useDropdown)({
        ref: buttonRef,
        offset: 1,
        renderControl: ({ actions, isActive }) => {
            return (react_1.default.createElement(TagInputControl_1.TagInputControl, Object.assign({}, rest, { hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, hasBlurEnter: hasBlurEnter, "data-selector-id": rest['data-selector-id'] || 'taginput', className: (0, helpers_1.cn)('vm-TagInput', className), placeholder: controlPlaceholder, focused: focused, active: active, disabled: disabled, value: receivedValue, error: controlError, inputError: newTagError, opened: isActive, canAdd: canAdd, hasSuggest: hasSuggest, data: data, onChange: onChange, size: size, maxNumberOfLines: maxNumberOfLines, searchTerm: searchTerm, onSearch: onSearchHandler, hasBorder: hasBorder, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onRequestOpen: () => {
                    actions.show();
                    activate();
                }, onRequestClose: () => {
                    actions.hide();
                    activate();
                }, validateNewTag: validateNewTag, onBlur: input.onBlur, onFocus: input.onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: buttonRef, style: style })));
        },
        renderPopover: ({ actions, popover }) => {
            if (!hasSuggest) {
                return null;
            }
            const { style } = popover;
            return (react_1.default.createElement(Suggest_1.Suggest, { ref: popover.ref, renderEmptyMessage: rendererEmptyMessage, searchTerm: searchTerm, textGetter: (item) => item.tag, onSelect: (item) => {
                    onChange === null || onChange === void 0 ? void 0 : onChange([...receivedValue, item.tag]);
                    setSearchTerm('');
                    actions.hide();
                }, filter: (i) => !(receivedValue === null || receivedValue === void 0 ? void 0 : receivedValue.includes(i.tag)), data: rendererData, renderTrailerItem: renderTrailerItem, onMouseDown: preventBlur, style: (0, getStylesWithMaxWidth_1.getStylesWithMaxWidth)(style) }));
        },
        dropdownWidth: Dropdown_1.DROPDOWN_WIDTH.minControlWidthAndMaxXXL
    });
    return control;
});
//# sourceMappingURL=TagInput.js.map